// extracted by mini-css-extract-plugin
export default {"box":"retailerFilterPage_box__khNqJ","box__content":"retailerFilterPage_box__content__6PSMw"};